import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import { initCronJobs } from './services/cronService';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// Initialize cron jobs
initCronJobs();

createRoot(rootElement).render(<App />);